import { fetchChinUsersFromInviteApi } from "../../Helpers/chin.js";
import { useInvitation } from "../../Stores/Invitation.js";
import {
    getActivityChinUsersFromConversationState,
    getActivityChinUsersSnapshot,
} from "./activityChinUserParticipants.js";

export {
    getActivityChinUsersFromConversationParticipants,
    getActivityChinUsersFromConversationState,
    getActivityChinUsersSnapshot,
    mapConversationParticipantToChinUser,
} from "./activityChinUserParticipants.js";

/**
 * @param {object | null | undefined} conversation
 * @returns {Promise<object[]>}
 */
export async function resolveActivityChinUsers(conversation) {
    if (!conversation) {
        return [];
    }

    const fromState = getActivityChinUsersFromConversationState(conversation);
    if (fromState !== null) {
        return fromState;
    }

    if (
        conversation.is_group_one_off ||
        conversation.is_group ||
        conversation.is_dm
    ) {
        return [];
    }

    const activityData = conversation.is_item
        ? conversation.originalData?.item
        : {
              entity_type: conversation.type,
              type_id: conversation.type_id,
              id: conversation.id,
              type: conversation.type,
          };

    if (!activityData) {
        return [];
    }

    const resource_type =
        useInvitation().RESOURCE_TYPES[
            activityData.entity_type ?? conversation.type
        ];

    return fetchChinUsersFromInviteApi(
        {
            selected_entities: [activityData],
            resource_type,
        },
        true,
    );
}
